export enum VideoSessionStatus {
  Scheduled = 0,
  Confirmed = 1,
  InProgress = 2,
  Completed = 3,
  Cancelled = 4,
  Expired = 5,
}

export const VideoSessionStatusLabels: Record<VideoSessionStatus, string> = {
  [VideoSessionStatus.Scheduled]: 'Agendada',
  [VideoSessionStatus.Confirmed]: 'Confirmada',
  [VideoSessionStatus.InProgress]: 'Em Progresso',
  [VideoSessionStatus.Completed]: 'Concluída',
  [VideoSessionStatus.Cancelled]: 'Cancelada',
  [VideoSessionStatus.Expired]: 'Expirada',
};

export const VideoSessionStatusColors: Record<VideoSessionStatus, string> = {
  [VideoSessionStatus.Scheduled]: 'blue',
  [VideoSessionStatus.Confirmed]: 'green',
  [VideoSessionStatus.InProgress]: 'orange',
  [VideoSessionStatus.Completed]: 'default',
  [VideoSessionStatus.Cancelled]: 'red',
  [VideoSessionStatus.Expired]: 'gray',
};
